/**
 * Copyright © Veeam Software Group GmbH.
 */

import { BackupAgentGuiModeRepresentation } from '@veeam-vspc/models/web-controllers';

export type EVawGuiModes = BackupAgentGuiModeRepresentation;
export const EVawGuiModes = BackupAgentGuiModeRepresentation;
